import { render, staticRenderFns } from "./ReturnBackState.vue?vue&type=template&id=a1220874&scoped=true"
import script from "./ReturnBackState.vue?vue&type=script&lang=js"
export * from "./ReturnBackState.vue?vue&type=script&lang=js"
import style0 from "./ReturnBackState.vue?vue&type=style&index=0&id=a1220874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1220874",
  null
  
)

export default component.exports